import { LazyLoadImage } from 'react-lazy-load-image-component'

// import sevenEleven from '../../assets/footer/7eleven.webp'
// import bancomer from '../../assets/footer/bancomer.webp'
// import banorte from '../../assets/footer/banorte.webp'
// import bbva from '../../assets/footer/bbva.webp'
// import benavides from '../../assets/footer/benavides.webp'
// import bodegaaurrera from '../../assets/footer/bodegaaurrera.webp'
// import calimax from '../../assets/footer/calimax.webp'
// import cash from '../../assets/footer/cash.webp'
// import circulok from '../../assets/footer/circulok.webp'
// import extra from '../../assets/footer/extra.webp'
// import farmaciadelahorro from '../../assets/footer/farmaciadelahorro.webp'
// import farmaciaroma from '../../assets/footer/farmaciaroma.webp'
// import hsbc from '../../assets/footer/hsbc.webp'
// import lacomer from '../../assets/footer/lacomer.webp'
// import mastercard from '../../assets/footer/mastercard.webp'
import newcastle from '../../assets/footer/newcastle.webp'
// import oxxo from '../../assets/footer/oxxo.webp'
// import paynet from '../../assets/footer/paynet.webp'
// import sams from '../../assets/footer/sams.webp'
// import santader from '../../assets/footer/santader.webp'
// import santamaria from '../../assets/footer/santamaria.webp'
// import scotiabank from '../../assets/footer/scotiabank.webp'
// import soriana from '../../assets/footer/soriana.webp'
// import stp from '../../assets/footer/stp.webp'
// import teleingreso from '../../assets/footer/teleingreso.webp'
// import visa from '../../assets/footer/visa.webp'
// import walmart from '../../assets/footer/walmart.webp'
// import useBlazeSlider from '../../hooks/useBlazeSlider'

// const PAYMENT_LOGOS = [
//   { img: oxxo, label: 'Oxxo' },
//   { img: mastercard, label: 'Mastercard' },
//   { img: visa, label: 'Visa' },
//   { img: sevenEleven, label: 'Seven Eleven' },
//   { img: banorte, label: 'Banorte' },
//   { img: bbva, label: 'BBVA' },
//   { img: benavides, label: 'Benavides' },
//   { img: bodegaaurrera, label: 'Bodegaaurrera' },
//   { img: calimax, label: 'Calimax' },
//   { img: cash, label: 'Cash' },
//   { img: circulok, label: 'Circulok' },
//   { img: extra, label: 'Extra' },
//   { img: farmaciadelahorro, label: 'Farmacias del Ahorro' },
//   { img: farmaciaroma, label: 'Farmacia Roma' },
//   { img: lacomer, label: 'La Comer' },
//   { img: paynet, label: 'Paynet' },
//   { img: sams, label: 'Sams' },
//   { img: santamaria, label: 'Santa Maria' },
//   { img: soriana, label: 'Soriana' },
//   { img: stp, label: 'STP' },
//   { img: teleingreso, label: 'Teleingreso' },
//   { img: walmart, label: 'Walmart' },
//   { img: bancomer, label: 'Bancomer' },
//   { img: hsbc, label: 'HSBC' },
//   { img: santader, label: 'Santader' },
//   { img: scotiabank, label: 'Scotia Bank' },
// ] as { img: string; label: string }[]

const Sponsors = () => {
  // const { elRef } = useBlazeSlider({
  //   "all": {
  //     loop: true,
  //     enableAutoplay: true,
  //     slidesToShow: 4,
  //     autoplayInterval: 50,
  //     transitionDuration: 2000,
  //     transitionTimingFunction: 'linear',
  //   },
  //   '(min-width: 768px)': {
  //     slidesToShow: 6,
  //   },
  //   '(min-width: 1280px)': {
  //     slidesToShow: 10,
  //   },
  // })

  return (
    <div className="px-5 py-0 xl:p-0">
      <div className="px-0 py-9 border-t-highlight border-t border-solid xl:pl-[30px] xl:pr-10 xl:py-10">
        <LazyLoadImage
          className="w-[250px] block aspect-[932_/_267] mt-0 mx-auto xl:w-[300px] xl:mt-0 xl:mx-auto"
          src={newcastle}
          alt="New Castle"
        />
        {/* <div className="sponsors-container blaze-slider" ref={elRef}>
          <div className="blaze-container">
            <div className="blaze-track-container">
              <div className="blaze-track">
                {PAYMENT_LOGOS.map((logo, index) => (
                  <div
                    className="flex justify-center items-center h-[50px] !w-fit px-3 py-0"
                    key={index}>
                    <LazyLoadImage
                      className="max-w-full max-h-full h-full"
                      src={logo.img}
                      alt={logo.label}
                      style={{ aspectRatio: '49 / 29' }}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  )
}

export default Sponsors
